export default {
  common: {
    more: "更多",
    langShortZh: "中",
    langShortEn: "EN",
    langShortTh: "TH",
    langZh: "中文",
    langEn: "English",
    langTh: "ไทย",
    searchPlaceholder: "搜索景点、攻略、资讯...",
    loading: "加载中...",
    loadingContent: "正在加载内容...",
    expandMore: "展开更多",
    collapse: "收起",
    print: "打印",
    go: "跳转",
    noContent: "暂无内容",
    comingSoon: "敬请期待",
    author: "作者：",
    publishTime: "发布时间：",
    phone: "电话：",
    address: "地址：",
    backHome: "返回首页",
    pageNotFound: "页面不存在",
    pageNotFoundDesc: "你访问的地址不存在或已被移动",
    underDevelopment: "功能模块定制开发中",
    cmsConfigHint: "内容配置中（请在 CMS 给文章/媒体打上「{tag}」标签）",
    noMediaContent: "暂无媒体内容",
    contentConfiguring: "内容配置中，敬请期待",
    pageNumber: "页码",
    defaultPublisher: "达古冰川管理局",
  },
  nav: {
    "/": "首页",
    "/about": "走进达古",
    "/about/intro/views": "景观详情",
    "/about/intro": "景区简介",
    "/about/honor": "景区荣誉",
    "/about/geology": "地质地貌",
    "/about/glacier-research": "民俗文化",
    "/about/RedCulture": "红军文化",
    "/about/ecology": "自然生态",
    "/about/experiment": "冰川保护",
    "/panorama": "全景达古",
    "/panorama/live": "景区慢直播",
    "/panorama/videos": "景区视频",
    "/panorama/shorts": "短视频图集",
    "/panorama/gallery": "景区图集",
    "/panorama/dagu-er": "达古er拍达古",
    "/service": "游客服务",
    "https://www.abatour.com/": "票务预订",
    "/service/food": "美食推荐",
    "/service/food/:id": "美食推荐详情",
    "/service/traffic": "交通指南",
    "/service/route": "精品线路",
    "/service/stay": "温馨住宿",
    "/service/stay/:id": "温馨住宿详情",
    "/service/specialty": "精致特产",
    "/service/play": "游玩攻略",
    "/service/entertainment": "休闲娱乐",
    "/service/entertainment/:id": "休闲娱乐详情",
    "/service/map": "景区导览",
    "/service/tips": "游客须知",
    "/service/products": "旅游产品",
    "/service/products/sunshine-snow": "阳光冰雪游",
    "/service/products/ice-summer": "冰雪消暑游",
    "/service/products/snow-mountain-forest": "雪山彩林游",
    "/service/products/glacier-science": "冰川科普游",
    "/service/products/red-culture": "红色文化游",
    "/service/questionnaire": "问卷调查",
    "/service/complaints": "游客投诉",
    "/gov": "政务中心",
    "/gov/politics": "党政要闻",
    "/gov/news": "景区新闻",
    "/gov/dynamic": "文旅动态",
    "/gov/employee": "职工风采",
    "/gov/media": "媒体聚焦",
    "/gov/notices": "官方公告",
    "/gov/procurement": "采购信息",
    "/gov/mailbox": "领导班子",
    "/gov/press": "新闻动态",
    "/marketing": "景区营销",
    "/marketing/brand": "品牌活动",
    "/marketing/promotion": "市场推介",
    "/marketing/cross": "跨界联动",
    "/marketing/mediaCare": "媒体关注",
    "/marketing/campaigns": "全民营销",
    "/marketing/party": "党政活动",
    "/marketing/units": "职工活动",
    "/study": "研学达古",
    "/news": "新闻中心",
    "/news/:id": "新闻详情",
    采购平台: "采购平台",
  },
  home: {
    heroTitle: "达古冰川",
    heroSub: "雪山之巅 · 云端之上 · 纯净之境",
    altitude: "海拔",
    realtime: "实时",
    latestNews: "最新资讯",
    photoStory: "图说达古",
    ticketing: "票务预订",
    live: "在线直播",
    ugc: "达古er拍达古",
    glacierCover: "冰川盖被子",
    glacierExperiment: "冰川保护",
    activities: "精彩活动",
    notices: "官方公告",
    research: "科研成果",
    emptyNotice: "暂无公告",
    viewDetail: "查看详情",
    ticketBooking: "官方售票渠道",
    heroAltitude: "景区海拔",
    heroOpenTime: "开放时间",
    heroBooking: "在线预订",
    heroConsult: "咨询电话",
    quickFood: "美食推荐",
    quickStay: "温馨住宿",
    quickRoute: "精品线路",
    quickGuide: "游玩攻略",
    quickSpecialty: "精致特产",
    quickLeisure: "休闲娱乐",
    // 新增移动端相关
    mobileTicketing: "票务预订",
    mobileLatestNews: "最新资讯",
    quickPhotoStory: "图说达古",
    quickLive: "在线直播",
    quickTraffic: "交通路线",
    quickTips: "参观须知",
    quickMap: "导览地图",
    quickProducts: "路线推荐",
    quickPlay: "游玩攻略",
    quickEntertainment: "休闲娱乐",
    weatherGuide: "天气指南",
    // 达古er拍达古
    daguErTitle: "达古er拍达古",
    daguErSubtitle: "用镜头记录，用照片表达，看看达古人眼中的不同达古。",
    // 冰川盖被子
    glacierCoverTitle: "冰川盖被子",
    glacierCoverText:
      "2020年，中国科学院在达古冰川开展全国首次冰川「盖被子」实验，通过在冰川表面铺设隔热反光材料以减缓消融，让达古冰川基本达到不消融或者消融很少的状态。",
    // 冰川实验
    glacierExperimentTitle: "冰川保护",
    glacierExperimentText:
      "达古冰川研学资源丰富、场景多样，形成「5个之旅、1个中心、8个节点」等研学产品格局，为四川省中小学生研学基地联盟会员单位。",
    // 精彩活动
    activitiesDesc:
      "为深入贯彻落实省、州关于文旅融合发展的重要决策部署，进一步扩大景区品牌影响力，达古冰川管理局积极开展各类全民营销，形成线上线下联动宣传新格局，有效提升景区知名度与吸引力。",
    // 在线预订
    onlineBooking: "在线预订",
    officialChannel: "官方售票渠道",
    consultPhone: "咨询电话",
  },
  homeData: {
    weatherLocation: "阿坝藏族羌族自治州",
    weatherCondition: "晴",
    researchFallback1:
      "论文：气候变化对自然资源的影响及可持续发展研究，以达古冰川为例",
    researchFallback2: "论文：达古冰川地质公园地质遗迹分区保护研究",
    researchFallback3: "论文：达古冰川地质公园地质遗迹资源及地学意义",
    researchFallback4: "专著：山地冰川与旅游可持续发展",
    researchFallback5: "达古冰川持续开展冰川观测",
  },
  ticket: {
    todayTicketRemaining: "今日门票已售",
    todayCablewayRemaining: "今日索道已售",
    sheets: "张",
    highest: "最高",
    lowest: "最低",
    traffic: "交通路线",
    tips: "参观须知",
    map: "导览地图",
    products: "路线推荐",
    openingTime: "开放时间",
    weatherGuide: "天气指南",
  },
  photoStory: {
    empty: "请在 CMS「图说达古」模块配置轮播图",
  },
  footer: {
    friends: "友情链接",
    surveys: "调查表",
    qrNeed: "需提供二维码",
    qrScan: "微信扫码",
    qrSub1: "扫描二维码进入手机端",
    qrSub2: "达古冰川官网",
    badge1: "国家4A级旅游景区",
    badge2: "中国国家地质公园",
    badge3: "省级风景名胜区",
    badge4: "四川省生态旅游示范区",
    badge5: "四川省生态文明示范基地",
    consult: "旅游咨询",
    complaint: "旅游投诉",
    reportPhone: "不良与违法信息举报电话",
    reportEmail: "举报邮箱",
    reportCenterCn: "中国互联网举报中心",
    reportCenterSc: "四川省互联网举报中心",
    channelDouyin: "抖音",
    channelXiaohongshu: "小红书",
    channelWeChat: "微信",
    channelWeibo: "微博",
    channelVoiceGuide: "语音讲解",
    qrDouyin: "抖音二维码",
    qrXiaohongshu: "小红书二维码",
    qrWechat: "微信二维码",
    qrWeibo: "微博二维码",
    qrVoiceGuide: "语音讲解二维码",
    qrMobileSite: "达古冰川手机官网二维码",
    friendLinks: {
      scGov: "四川省人民政府",
      abaGov: "阿坝州人民政府",
      jiuzhai: "九寨沟",
      huanglong: "黄龙景区",
      siguniang: "四姑娘山",
      abaTour: "阿坝旅游网",
      cctv: "中央电视台",
      sctv: "四川电视台",
      sina: "新浪网",
    },
    surveyNationalStandard: "国家旅游局标准版游客意见收集表",
    surveySatisfaction: "国家旅游局标准版游客满意度调查表",
    surveyNationalStandardQuery: "国家旅游局标准版游客意见收集表",
    surveySatisfactionQuery: "国家旅游局标准版游客满意度调查表",
  },
  gov: {
    tabs: {
      all: "全部",
      politics: "党政要闻",
      news: "景区新闻",
      dynamic: "文旅动态",
      employee: "职工风采",
      media: "媒体聚焦",
      notices: "官方公告",
      procurement: "采购信息",
      mailbox: "领导班子",
      press: "新闻动态",
    },
    jump: "跳转",
  },
  gallery: {
    loadMore: "展开更多",
    prevImage: "上一张",
    nextImage: "下一张",
    noImage: "暂无图片",
    untitled: "未命名图片",
  },
  intro: {
    title: "景区简介",
    moreContent: "更多景区内容",
    description:
      "达古冰川景区，地处青藏高原东南缘，位于四川省阿坝州黑水县境内，东临茂县古羌城，西接红原大草原，南依理县毕棚沟，北靠黄龙景区，距成都260公里、红原机场90公里、茂县高铁站120公里。不翻山而穿越高山峡谷、不冒雪而置身林海雪原、不登山而屹立群山之巅是达古冰川的真实写照。景区集冰雪体验、生态观光、康养避暑、科考研学、婚纱旅拍于一体，以其无滤镜的自然美景吸引世人，先后被评为国家4A级旅游景区、国家地质公园、省级生态旅游示范区，是我国纬度最北、距离中心城市最近、可进入性最便捷的海洋性季风现代山地冰川，被誉为最近的遥远。",
    spots: {
      daguLake: "达古湖",
      loversBeach: "情人滩",
      goldenMonkeySea: "金猴海",
      zenaco: "泽娜措",
      mountLogos: "洛格斯神山",
      glacierSummit: "4860冰川之巅",
    },
  },
  header: {
    logoAlt: "达古冰川",
    searchAlt: "搜索",
    dropdownAlt: "下拉",
  },
  video: {
    noPlayableUrl: "暂无可播放地址",
    unnamedVideo: "未命名视频",
  },
  news: {
    externalLinkNotice: "本篇内容为外部链接：",
    noExternalLink: "暂未配置外链地址。",
    articleNav: "文章导航",
    previousArticle: "上一篇",
    nextArticle: "下一篇",
    noPreviousArticle: "已经是第一篇",
    noNextArticle: "已经是最后一篇",
    relatedTitle: "相关推荐",
  },
  geology: {
    comingSoon: "敬请期待更多地质地貌内容",
    title: "地质地貌",
    viewMore: "查看更多",
  },
  ecology: {
    title: "自然生态",
    geologySection: "地质地貌",
    biologySection: "生物篇",
    animalOverview: "达古冰川动物概述",
    plantOverview: "达古冰川植物概述",
    noGeologyData: "暂无地质数据",
    noBioData: "暂无自然生态数据",
    noContent: "暂无内容",
    moreGeologyComing: "敬请期待更多地质内容",
    moreBioComing: "敬请期待更多生物内容",
  },
  glacier: {
    experimentTitle: "冰川保护",
    researchTitle: "民俗文化",
    noExperimentData: "暂无冰川保护数据",
    noResearchData: "暂无民俗文化数据",
    noRedCultureData: "暂无红军文化数据",
  },
  honor: {
    title: "景区荣誉",
    noHonors: "暂无荣誉称号",
    comingSoonHint: "敬请期待更多荣誉内容",
    viewMore: "查看更多",
  },
  modal: {
    close: "关闭",
    prev: "上一张",
    next: "下一张",
    imageLoadError: "图片加载失败",
  },
  live: {
    liveNow: "直播中",
    connecting: "正在连接直播流...",
    invalidUrl: "无效的直播地址",
    loadFailed: "直播加载失败",
    browserNotSupported: "您的浏览器不支持直播播放",
    title: "直播",
    loadError: "直播加载失败，请稍后重试",
    browserNotSupportedMsg:
      "当前浏览器不支持 m3u8 播放，请使用 Safari 或升级浏览器",
    clickToRetry: "点击重试",
  },
  tips: {
    noContent: "暂无游客须知内容",
    comingSoon: "敬请期待更多游客须知信息",
  },
  traffic: {
    noContent: "暂无交通指南信息",
    comingSoon: "敬请期待更多交通指南内容",
  },
  service: {
    complaintPhone: "投诉电话",
  },
  serviceHomePage: {
    ticketBooking: "票务预订",
    officialNotices: "官方公告",
    openingTime: "开放时间",
    peakSeason: "旺季",
    offSeason: "淡季",
    scenicOpenTime: "景区开放时间：",
    ticketPrice: "门票",
    cablewayPrice: "索道",
    sightseeingCarPrice: "观光车",
    visitorTips: "游客须知",
    trafficGuide: "交通指南",
    scenicMap: "景区导览",
    tourismProducts: "旅游产品",
    businessRecommendation: "业态推荐",
    questionnaire: "问卷调查",
    complaint: "游客投诉",
    consultPhone: "咨询电话",
    viewMap: "查看景区导览大图",
    scanQRCode: "扫描小程序二维码填写问卷调查",
    configurableImage: "可配置图片",
    mapPreviewTitle: "景区导览大图预览",
    close: "关闭",
    // 快捷入口
    quickOpenTime: "开放时间",
    quickOpenTimeSub: "08:00—17:00",
    quickBooking: "票务预订",
    quickBookingSub: "官方售票渠道",
    quickAltitude: "景区海拔",
    quickAltitudeSub: "2300—4860m",
    quickTraffic: "交通指南",
    quickTrafficSub: "让旅行更便捷",
    quickMap: "景区导览",
    quickMapSub: "为您提供合理行程路线",
    quickTips: "游客须知",
    quickTipsSub: "让您的旅途更安心",
    // 交通指南
    highwayRoute: "高速路线",
    railRoute: "高铁路线",
    flightRoute: "航空路线",
    trafficRoute1: "成都 → 都江堰 → 汶川 → 茂县 → 黑水县 → 达古冰川",
    trafficRoute2: "成都东站（高铁） → 茂县站 → 换乘汽车 → 黑水县 → 达古冰川",
    trafficRoute3: "成都天府机场 / 双流机场 → 红原机场 → 达古冰川",
    productsDesc:
      "达古冰川依托亿年冰川、四季盛景、地质奇观与红色文脉、匠心打造阳光冰雪游、冰雪消暑游、雪山彩林游、冰川科普游、红色文化游五大核心产品，构建全季、全龄、全体验的高原文旅精品体系，让自然之美、科普之趣、人文之韵一站式呈现。",
    consultPhoneLabel: "咨询电话",
    complaintPhoneLabel: "投诉电话",
    // 价格标签
    ticketLabel: "门 票：",
    busTicketLabel: "车 票：",
    cablewayTicketLabel: "索道票：",
    ticketSalesTime: "景区售票时间：",
    yearRound: "（全年）",
    // 价格
    peakSeasonTicketPrice: "120元",
    peakSeasonBusPrice: "70元",
    peakSeasonCablewayPrice: "120元",
    offSeasonTicketPrice: "80元",
    offSeasonBusPrice: "70元",
    offSeasonCablewayPrice: "100元",
    // 交通时刻表
    trafficSchedule1: "达古冰川景区夏季基础内容交通行程时刻表",
    trafficSchedule2: "黑水县汽车站发班时刻表",
    trafficSchedule3: "阿坝大客运站线路时刻表以及阿坝大客运站分公司...",
    tipsHalfTitle: "【门票半价优惠的范围和群体】",
    tipsHalfItem1:
      "1、青少年(儿童、学生、未成年人):6周岁(不含6周岁)至18周岁(含18周岁)未成年人、全日制大学本科及以下学历学生、持港澳居民来往内地通行证、台湾居民来往大陆通行证或学生证等有效证件的香港澳门、台湾等入境游青少年。",
    tipsHalfItem2: "2、老年人:60周岁至64周岁的老年人(国家法定节假日)。",
    tipsHalfItem3:
      "3、宗教界人士:持省级以上宗教团体统一印发的皈依证等有效证件的同一宗教信教群体。",
    tipsFreeTitle: "【门票免票优惠的范围和群体】",
    tipsFreeItem1:
      "1、未成年人:6周岁(含6周岁)以下或身高1.2米(含1.2米)以下的儿童享受门票、观光车票和索道票免票。",
    tipsFreeItem2:
      "2、老年人:65周岁以上老年人、60周岁至64周岁的老年人(非国家法定节假日)享受免门票，需另购全价观光车票和索道票。",
    tipsFreeItem3:
      "3、现役军人、退役军人、残疾军人、离休干部和我州重建纪念章获得者享受门票免票，需另购全价观光车票和索道票。",
    tipsFreeItem4:
      "4、残疾人凭残疾人证件实行免票。对盲人和重度肢体、智力、精神残疾人允许一名陪护人员陪同并免票。",
    tipsNote:
      "以上群体游览时须持户口簿、身份证、军官证、残疾军人证、离休证等有效证件进行登记、验证后，方能享受检票优惠。",
    // 旅游产品
    productSunshineSnow: "阳光冰雪游",
    productIceSummer: "冰雪消暑游",
    productSnowMountainForest: "雪山彩林游",
    productGlacierScience: "冰川科普游",
    productRedCulture: "红色文化游",
    // 业态推荐
    bizFood: "美食推荐",
    bizStay: "温馨住宿",
    bizRoute: "精品线路",
    bizPlay: "游玩攻略",
    bizSpecialty: "精致特产",
    bizLeisure: "休闲娱乐",
  },
  campaignsPage: {
    title: "全民营销",
    all: "全部",
    loadMore: "展开更多",
    yearSuffix: "年",
  },
  govPage: {
    externalLinkNotice: "本篇内容为外部链接：",
    noExternalLink: "暂未配置外链地址。",
    loadingContent: "正在加载内容...",
    noContent: "暂无内容",
    externalLink: "外部链接",
  },
  govPortal: {
    pageTitle: "政务中心",
    leadershipTeam: "{'|'} 领导班子",
    politics: "党政要闻",
    scenicNews: "景区新闻",
    scenicNewsPrefix: "{'|'} 景区新闻",
    mediaFocus: "媒体聚焦",
    officialNotices: "官方公告",
    officialNoticesPrefix: "{'|'} 官方公告",
    procurement: "采购信息",
    procurementPrefix: "{'|'} 采购信息",
    mailbox: "领导邮箱",
    viewMore: "查看更多",
    configurableImage: "可配置图片",
    defaultName: "代用名",
    defaultRole: "职级名称",
    defaultAddress: "邮寄地址",
    defaultText:
      "文字可配置文字可配置文字可配置文字可配置文字可配置文字可配置文字可配置文字可配置文字可配置文字可配置文字可配置。",
    mockContentPrefix: "这是用于页面联调的示例内容（",
    mockContentSuffix: "）。",
    sample: "示例",
  },
  marketing: {
    // 品牌活动
    brandTitle: "品牌活动",
    brandSubtitleDesktop:
      "塑造标志，创造期待。以鲜明的主题，创造深度体验与独特记忆。",
    brandSubtitleMobile:
      "塑造标志，创造期待。<br>以鲜明的主题，创造深度体验与独特记忆。",
    brandAlt: "品牌活动",
    // 市场推介
    promotionTitle: "市场推介",
    promotionSubtitle:
      "面向重点客源市场，开展主题推介与渠道合作，以全球视野开拓旅游新局面。",
    // 跨界联动
    crossTitle: "跨界联动",
    crossSubtitle:
      "跨领域合作、新跨界模式，在与各领域和知名项目的联动协作中，拓宽了营销渠道。",
    crossPrefix: "{'|'} 跨界联动",
    // 媒体关注
    mediaCareTitle: "媒体关注",
    mediaCareSubtitle:
      "权威媒体关注、优秀案例报道、相关记者报道专栏的有效传播，形成立体、高效合作。",
    // 全民营销
    campaignsTitle: "全民营销",
    campaignsPrefix: "{'|'} 全民营销",
    campaignsSubtitle:
      "线上线下联动，形成全民参与的宣传新格局，最具创新力全民营销战的全过程中共有100+个精彩项目。",
    // 党政活动
    partyTitle: "党政活动",
    partySubtitle:
      "党建活动、领导关怀、人大政协代表视察、相关职部门交流座谈等。",
    // 职工活动
    unitsTitle: "职工活动",
    unitsSubtitle:
      "锤炼精气神铸魂、业务培养匠心、定期活动凝心聚力、业务竞赛催生干劲。",
    // 通用
    viewMore: "查看更多",
    more: "更多",
    morePlus: "更多+",
    clickForDetails: "点击了解详情",
    activityTitlePlaceholder: "这里是活动标题！",
    configurableTitle: "可配置文字标题",
    configurableImage: "可配置图片",
    defaultDate: "2025-00-00 00:00",
  },
  backToTop: {
    label: "回到顶部",
  },
  breadcrumb: {
    currentPosition: "当前位置：",
    home: "首页",
  },
  pages: {
    immersiveCloudTour: {
      liveStream: "景区慢直播",
      videos: "景区视频",
      shortsCollection: "短视频合集",
      more: "更多",
      gallery: "景区图集",
      viewMore: "查看更多",
      daguEr: "达古er拍达古",
      daguErDesc: "用镜头记录，用照片表达。看看达古人眼中的不同达古",
      noPlayableUrl: "暂无可播放地址",
      noImage: "暂无图片",
      unnamedVideo: "未命名视频",
      unnamedWork: "未命名作品",
      galleryDesc:
        "一山藏四季，四时皆盛景。达古冰川，是藏在川西高原的天然画卷，更是一年四季皆可游、皆可赏的世界级生态旅游目的地。",
      galleryDesc2:
        "春日冰雪初融，山花次第绽放，冰川与花海相映，温柔治愈；夏日清凉宜人，林海葱郁、湖水澄澈，在海拔4860米邂逅云端清凉；秋日彩林漫山，层林尽染，雪峰与红叶共舞，绘就川西醉美秋色；冬日银装素裹，蓝冰剔透、雾凇晶莹，尽显圣洁雪域的纯净与壮阔。",
      seasons: {
        spring: "春",
        springName: "赏花玩雪",
        springDesc1: "达古冰川之春，",
        springDesc2: "一半冰雪覆巅峰，",
        springDesc3: "一半繁花缀山涧，",
        springDesc4: "定格高原限定奇景。",
        summer: "夏",
        summerName: "休闲避暑",
        summerDesc1: "达古冰川之夏，",
        summerDesc2: "林海纳清欢，",
        summerDesc3: "冰湖送微凉，",
        summerDesc4: "藏尽高原避暑秘境。",
        autumn: "秋",
        autumnName: "红叶彩林",
        autumnDesc1: "达古冰川之秋，",
        autumnDesc2: "红叶燃层林，",
        autumnDesc3: "冰川衬彩韵，",
        autumnDesc4: "尽揽高原秋日盛景。",
        winter: "冬",
        winterName: "冰雪天堂",
        winterDesc1: "达古冰川之冬，",
        winterDesc2: "琼枝覆冰雪，",
        winterDesc3: "巅峰揽皑然，",
        winterDesc4: "定格高原冰雪天堂。",
      },
    },
    panoramaGallery: {
      title: "景区图集",
      spring: {
        seasonTitle: "春季图集",
        title: "春·赏花玩雪",
        subtitle:
          "达古冰川之春，半冰系覆雪峰，半繁花缀山间，定格高原限定奇景。",
      },
      summer: {
        seasonTitle: "夏季图集",
        title: "夏·休闲避暑",
        subtitle: "达古冰川之夏，林海纳清欢，冰湖送微凉，藏尽高原避暑秘境。",
      },
      autumn: {
        seasonTitle: "秋季图集",
        title: "秋·红叶彩林",
        subtitle: "达古冰川之秋，红叶燃层林，冰川衬彩韵，尽揽高原秋日盛景。",
      },
      winter: {
        seasonTitle: "冬季图集",
        title: "冬·冰雪天堂",
        subtitle: "达古冰川之冬，琼枝覆冰雪，巅峰揽皑然，定格高原冰雪天堂。",
      },
    },
    scenicIntro: {
      bannerLoading: "轮播图加载中...",
      collapse: "收起",
      expand: "展开",
      characteristicLandscape: "特色景观",
      noLandscape: "暂无特色景观",
      comingSoonHint: "敬请期待更多精彩内容",
    },
    productTours: {
      sunshineSnow: {
        title: "阳光冰雪游",
        heroAria: "阳光冰雪游",
        previewAria: "阳光冰雪游推荐景点速览",
        detailAria: "阳光冰雪游详细介绍",
        imageLoadFailed: "图片加载失败",
        introLines: [
          "冰山之巅雪飞扬，金猴海边桃花放，雪与花比舞报春晓。",
          "放生湖洗涤人生烦事扰，",
          "鸿运坡祈福来年旺；",
          "红军桥上忆长征，藏家珍馐美味尝；",
          "泪湖爱神降，山盟海誓情更长。",
        ],
        cards: [
          { id: "ig28", title: "上达古藏寨" },
          { id: "ig29", title: "金猴海栈道" },
          { id: "ig30", title: "鸿运坡" },
        ],
        spots: [
          {
            id: "shang-dagu",
            title: "上达古藏寨",
            paragraphs: [
              "上达古藏寨位于达古冰川深处，是三达古藏寨之一，为原生态安多藏族聚居地，海拔约3800米，始建于明代，底蕴深厚。",
              "藏寨依山而建，红蓝民居错落，云雾缭绕如仙境。这里民风淳朴，保留传统民俗，亦是红军长征途经地，红韵与藏情交融，独具魅力。漫步寨中，可赏冰川彩林环抱之景，体验地道藏家风情，感受高原村落的宁静厚重。",
            ],
          },
          {
            id: "jin-hou-hai",
            title: "金猴海栈道",
            paragraphs: [
              "金猴海栈道是达古冰川入园首站秘境，沿湖畔蜿蜒穿梭于原始森林间，溪水潺潺相伴。这里常遇藏酋猴嬉戏觅食，湖光映彩林、衬经幡，野趣与高原景致交融，尽显灵动生机。",
            ],
          },
          {
            id: "hongyunpo",
            title: "鸿运坡",
            paragraphs: [
              "鸿运坡地处达古河谷，海拔3600至3700米，是第四纪冰川退去后留下的冰渍石景观。因石上生长乔利橘色藻呈艳丽赭红，搭配潺潺溪流与周遭景致，色差对比强烈。",
              "当地流传红财神显圣的传说，这里也成为旅人祈福纳祥之地，四季风情各异，红石映雪山、衬彩林，尽显高原自然与人文交融的独特韵味。",
            ],
          },
        ],
      },
      iceSummer: {
        title: "冰雪消暑游",
        heroAria: "冰雪消暑游",
        detailAria: "冰雪消暑游详细介绍",
        introLines: [
          "徜徉四十里花海长廊，身临达古美景鸟语花香。",
          "乘世界之最索道观万亩杜鹃绽放，",
          "转洛格斯神山福佑圆心愿；",
          "驼峰岭下氤氲氧绕，泽娜措边清肺心神爽，避暑消夏没有蚊虫咬。",
        ],
        spots: [
          {
            id: "rhododendron",
            title: "万亩杜鹃林",
            paragraphs: [
              "达古冰川万亩杜鹃林，有“中国第一高山杜鹃林”之誉，扎根于海拔3800至4200米高原。",
              "5至6月，红粉白紫杜鹃次第绽放，簇拥成海，在雪山冰川映衬下愈显灵动。金猴海周边群落最密，偶有藏酋猴穿梭，野趣与花海相融，是春夏高原必赏盛景。",
            ],
          },
          {
            id: "mountain",
            title: "洛格斯神山",
            paragraphs: [
              "洛格斯神山藏语意为“群山守护神”，海拔4000余米，是达古冰川的灵魂秘境。主峰轮廓似“睡美人”与大佛，惟妙惟肖。",
              "这里流传姐妹化湖传说，遍布玛尼堆与经幡，是藏族同胞的朝圣之地。山间有珍稀动物出没，徒步小径穿原始森林，四季皆景，是自然与信仰交融的心灵秘境。",
            ],
          },
          {
            id: "lake",
            title: "东措日月海",
            paragraphs: [
              "东措日月海是达古冰川海拔4300米处的璀璨明珠，也是园区最大冰川湖泊。两湖相连形似哑铃，湖水碧绿澄澈，在阳光下泛着蓝宝石般光泽，雪山草甸倒映其间，构成绝美画卷。",
              "这里四季景致各异，冬季湖面覆雪成天然冰雪场地，夏季则如宝石镶嵌山间。作为藏民心中的“神湖”，它承载着古老信仰与传说，乘坐索道俯瞰，湖光山色令人流连忘返。",
            ],
          },
        ],
      },
      snowMountainForest: {
        title: "雪山彩林游",
        heroAria: "雪山彩林游",
        miniCardsAria: "雪山彩林游精选点位",
        detailAria: "雪山彩林游详细介绍",
        introLines: [
          "金秋时节，五彩斑斓层林尽染，峡谷、雪山、藏寨、湖泊彩色画卷幅幅展。",
          "置身于中国首批非物质文化遗产卡斯达温的故乡，",
          "冰川晶莹剔透，雪山超凡脱俗，",
          "彩林美轮美奂，是亚洲大型冰雪彩林旅游胜地。",
        ],
        miniCards: [
          { title: "花楸王" },
          { title: "牛棚子" },
          { title: "鸿运坡" },
        ],
        spots: [
          {
            id: "flower-king",
            title: "花楸王",
            paragraphs: [
              "达古冰川花楸王，是彩林核心区极具代表性的标志性景致。它扎根于高原沃土，树龄久远，树形挺拔秀美、枝繁叶茂，四季风情各异、各有韵味。",
              "初夏枝桠缀满洁白小花，似覆薄雪、素雅清新；秋日褪去翠绿，红叶似火，缀满圆润红果，红绿相映，在雪域天光的映衬下格外绚烂夺目，尽显高原自然的蓬勃生机。",
            ],
          },
          {
            id: "niubianzi",
            title: "牛棚子",
            paragraphs: [
              "牛棚子坐落于达古冰川神牛湖畔，紧邻红军桥，是景区核心彩林观赏地之一。地处海拔3500米左右的高原地带，秋日里红楸、黄桦与翠绿松柏交相辉映，层林尽染间盛满高原秋韵。",
              "每年国庆至11月中旬是最佳观赏期，阳光洒落时光影斑驳，尽显雪域彩林的绚烂风情，宛如冰山脚下流淌的高原牧歌。",
            ],
          },
          {
            id: "hongyunpo",
            title: "鸿运坡",
            paragraphs: [
              "鸿运坡地处达古河谷，海拔3600至3700米，是第四纪冰川退去后留下的冰渍石景观。因石上生长乔利橘色藻呈艳丽赭红，搭配潺潺溪流与周遭景致，色差对比强烈。",
              "当地流传红财神显圣的传说，这里也成为旅人祈福纳祥之地，四季风情各异，红石映雪山、衬彩林，尽显高原自然与人文交融的独特韵味。",
            ],
          },
        ],
      },
      glacierScience: {
        title: "冰川科普游",
        heroAria: "冰川科普游",
        pairAria: "冰川科普游图片预览",
        sectionsAria: "冰川科普游分节内容",
        summitAria: "4860冰川之巅",
        introLines: [
          "情人滩边玩雪，凌云瀑布赏冰；",
          "罗毕牧场雪飞扬、梦畅想，达古湖天然滑冰场，青春在燃烧；",
          "下达古猴哥爱热闹，4860品一杯咖啡，人生滋味自己尝；",
          "顶达古山顶，群山连绵尽在脚下，不挑战自我怎能释放豪情万丈！",
        ],
        sections: [
          {
            id: "lover-lake",
            title: "情人滩",
            desc: "漫步情人滩，尽赏“冰川之恋”北欧风情。这里是藏族情侣幽会秘境，藏着动人传说：部落头人峨太旺的三女与村中三兄弟互生情愫，老大泽拉旺为大姐卓玛山歌传情，卓玛倚栏相和。亲友相助下，二人常于冰川脚下相会，初吻印在亿年冰川，天地为证，定格炽热爱意。以神山为誓、冰川为媒，许下不离不弃之约，在这离太阳最近的冰川，续写不朽爱恋。",
          },
          {
            id: "village-view",
            title: "藏酋猴观赏区",
            desc: "达古冰川藏酋猴观赏区，是亲近野生藏酋猴的天然秘境。成群猴群灵动活泼，不惧游人，可近距离观其嬉戏觅食的憨态，感受人与自然相融的野趣。",
          },
        ],
        summit: {
          title: "4860冰川之巅",
          paragraphs: [
            "4860冰川之巅是达古冰川的核心地标，坐落于索道上站，以海拔4860米的高度定格雪域壮阔。这里矗立着亿年冰川，终年积雪覆顶，澄澈苍穹下云海翻涌，连绵雪峰尽收眼底，尽显“会当凌绝顶”的豪迈。",
            "全球海拔最高的云端咖啡屋坐落于此，全景落地窗将雪山盛景框成画卷，搭配玛尼堆的祈福意蕴，让自然震撼与人文浪漫在此交融，成为俯瞰冰川、治愈心灵的必至之地。",
          ],
        },
      },
      redCulture: {
        title: "红色文化游",
        heroAria: "红色文化游",
        sculptureAria: "红军雕塑群",
        detailAria: "红色文化游详细介绍",
        introLines: [
          "昌德雪巅寻足迹，红军桥畔忆初心；",
          "红军湖畔风低语诉峥嵘，芦花会址藏岁月，信仰在传承；",
          "鸿运坡前承荣光，红色展馆溯来路，革命精神心中驻；",
          "重走长征故道，热血初心滚烫，不踏红土怎懂山河无恙的担当！",
        ],
        sculpture: {
          title: "红军雕塑群",
          text: "红军雕塑群《北上、北上》坐落于红军桥下游河谷，是达古冰川红色文化地标。以雕塑定格红军长征翻越雪山、途经黑水的壮阔历程，承载着不朽革命记忆，与高原景致相融，彰显长征精神。",
        },
        spots: [
          {
            id: "changde",
            title: "昌德雪山",
            paragraphs: [
              "昌德雪山位于四川阿坝州黑水县沙石多乡境内，海拔4283米。它是红军长征途中翻越的重要雪山之一，1935年7月上旬，红一方面军在此历经艰难险阻，在当地藏族群众的带路下成功翻越。",
              "如今，昌德雪山脚下的昌德村已成为“红色村”。每年端午，村里的青壮都会背负祭品，踏着先辈足迹到达半山腰，举行庄严的祭拜仪式，以缅怀先烈，传承长征精神。昌德雪山不仅是一座自然之山，更是一座承载着厚重红色历史和民族精神的圣山。",
            ],
          },
          {
            id: "red-army-lake",
            title: "红军湖",
            paragraphs: [
              "红军湖坐落于达古冰川景区腹地，是承载着长征记忆的红色地标。1935年，红军翻越4200多米的昌德雪山后，曾在此安营扎寨，当地藏族群众为缅怀红军壮举，特命名此湖为“红军湖”。",
              "湖面静谧如镜，墨绿的湖水透着深邃沉稳，恰似红军战士坚韧不拔的革命信念。它不仅见证了红军长征途中的艰辛与坚守，更定格了军民同心的温情瞬间，如今已是感悟长征精神、串联红色游览线路的重要景点。",
            ],
          },
          {
            id: "red-army-bridge",
            title: "红军桥",
            paragraphs: [
              "红军桥坐落于达古冰川景区三达古村河谷地带，是镌刻着长征记忆的红色地标。1935年7月，红军途经此处时，为突破阻碍与反动势力激战夺桥，这座临时搭建的木桥成为北上关键通道，后当地群众为缅怀先烈定名“红军桥”。",
              "桥下冰川融水奔涌，桥畔藏寨错落，这里既是连通自然景致的要道，更是传承不怕牺牲、坚韧不拔长征精神的重要载体。",
            ],
          },
        ],
      },
    },
    scenicSpotIntroductionViews: {
      heroAlt: "景观图",
      defaultImageAlt: "景观图",
      detail: {
        title: "达古湖",
        paragraphs: [
          "在藏语里“达”是“冰川”，“古”是“深沟”，“达古”即为“深沟里的冰川”。达古湖是由千年冰川融化的冰水汇聚而成，湖色随季节而变幻。分外妖娆的达古湖，让天空放低身段，用心灵感怀人生。",
          "雪山之巅，冰原之上，静静地与自己心灵做了一次最直接的沟通。你可以冥想，也可以高歌，还可以放下所有的世俗杂念、人生的是非对错，最虔诚地与神山、与苍穹、与梦中情人交心。",
          "春入山谷，阳光透过林梢落下斑驳的影子，嫩芽在深褐色的枝杆上绽放，一派新黄嫩绿的柔融景象，成林成遍的野花在湖边招展着美丽的裙裾。",
          "金秋，漫山的彩林倒影在湖中，使湖色变得五彩斑斓，不时有野鸭成群嬉戏于湖间，伴以远山风光，构成一幅天然的画卷。",
        ],
      },
      gallery: [
        { id: 1, title: "达古湖全景" },
        { id: 2, title: "原始森林" },
      ],
    },
    study: {
      heroAlt: "达古冰川",
      fiveResources: "五大研学资源",
      fiveTravels: "5个之旅",
      studySystem: `"1+8+N"达古冰川研学体系`,
      outdoorStations: "8大户外研学驿站",
      oneCoreHub: "1个核心研学枢纽",
      coreHubDesc:
        "研学中心：达古冰川研学中心总建筑面积1200㎡，分为星际冰川、冰川地貌、冰川守护、冰川人文、冰川生物等5个功能区，涵盖6间主题教室、5间实验室、4间主题展厅、1间流媒体教室、1间交流报告厅。",
      resources: {
        r1Title: "01 冰川地质遗迹",
        r1Sub:
          "核心价值：世界年纪最轻的冰川 离大都市最近的冰川 可接触性最强的冰川",
        r1Desc1: `达古冰川形成于200万年前，是青藏高原东缘少有的受东南季风影响的现代海洋性冰川分布区，是我国纬度最北的海洋性现代山地冰川，被地质专家称为"冰川遗迹百花园"。`,
        r1Desc2: `分布有冰斗冰川、悬冰川、坡面冰川等多种冰川类型。冰川地貌典型（如冰斗、冰川弧拱、刃脊）以及褶皱等地质景观，是研究第四纪冰川活动、气候变化历程以及地貌演化规律的"活化石"和"天然实验室"。`,
        r2Title: "02 垂直生态系统",
        r2Sub: `核心价值：从山脚2300米至山顶4860米，植物高山垂直带谱分布明显，呈现"生物多样性垂直画卷"。`,
        r2Desc:
          "拥有国家一级保护植物红豆杉、国家二级保护植物桃儿七、红花绿绒蒿、独叶草等形态特征与生存智慧；有川金丝猴、雪豹、岩羊等野生动物。是生物多样性的璀璨宝库，也是生态过渡带的典范。",
        r3Title: "03 类火星地貌",
        r3Sub: `核心价值：达古冰川的U型谷、冰斗、鲸背岩群等地貌与火星表面的叶状碎屑坡（LDA）、类冰川地貌（GLF）等形态高度相似，均可能蕴含水冰或记录古气候信息，是行星地质学和地外宜居性研究的理想类比地，是"地球上的火星课堂"。`,
        r4Title: "04 冰川保护实验",
        r4Sub: `核心价值：在连续6年的冰川保护（"冰川盖被子"）实验中取得了显著效果，能够减缓冰川消融厚度达到2.3米，初步估计减缓了约75%的冰川消融。`,
        r4Desc1: `初步估计减缓了约75%的冰川消融。"冰川盖被子"的实验原理：传统土工织布的实验原理是怎样的？`,
        r4Desc2: "纳米材料与传统土工织布保护冰川的方法，在原理上有着质的区别。",
        r4Desc3:
          "传统土工织布是主动式，通过阻隔大气与冰川的热量交换的原理来实现减缓冰川消融；",
        r4Desc4: `新型辐射制冷纳米材料是被动式，不消耗任何能源，通过减少能量摄入、增强太阳反照率、增强自身中红外窗口的能量发射的原理来实现减缓冰川消融"。`,
        r5Title: "05 红色记忆与民俗传承",
        r5Sub1: `核心价值：达古冰川景区是红军长征过程中唯一途经的4A级旅游景区，红军在景区先后翻越了昌德雪山、达古雪山，留下了红军湖、红军桥等红色遗迹，流传了《吃冰激凌》等故事，是"雪山下的红色丰碑"。`,
        r5Sub2: `景区周边生活的嘉绒藏族与景区内生活的安多藏族形成对比，其独特的语言、服饰、宗教、建筑、歌舞及人与自然和谐共生的生态智慧，是"神山圣湖间的智慧"。`,
      },
      travels: {
        t1: "{'|'} 全球最年轻冰川地貌解码之旅",
        t2: "{'|'} 中国唯一入选全球濒危冰川守护之旅",
        t3: "{'|'} 冰川脚下长征足迹与民俗共生之旅",
        t4: "{'|'} 青藏高原东缘高山生物多样性垂直带谱发现之旅",
        t5: "{'|'} 地球最接近火星地貌冰川谷地研学之旅",
      },
      stations: {
        s1: "{'|'} 雪域生灵研学驿站",
        s2: "{'|'} 达古藏寨研学驿站",
        s3: "{'|'} 红军桥研学驿站",
        s4: "{'|'} 红石滩研学驿站",
        s5: "{'|'} 达古湖研学驿站",
        s6: "{'|'} 冰川湿地研学驿站",
        s7: "{'|'} 孑遗花园研学驿站",
        s8: "{'|'} 4860类火星地貌研学驿站",
        s9: "{'|'} N节特色研学课堂",
      },
      centerImgAlt: "中心图",
      stationImgAlt: "驿站",
      travelAlt: "旅行",
      specialClassroom: "{'|'} N节特色研学课堂",
    },
    honors: {
      title: "荣誉称号",
      all: "全部",
      yearSuffix: "年",
      yearTitle: "年度",
      noHonors: "暂无荣誉称号",
      comingSoonHint: "敬请期待更多荣誉内容",
    },
    glacierExperiment: {
      title: "冰川保护",
      noContent: "暂无内容",
      comingSoonHint: "敬请期待更多冰川保护内容",
      pageNumber: "页码",
      jump: "跳转",
    },
    glacierResearch: {
      title: "民俗文化",
      noContent: "暂无内容",
      comingSoonHint: "敬请期待更多{title}内容",
      pageNumber: "页码",
      jump: "跳转",
    },
  },
  newsListPage: {
    mockItems: [
      {
        title: "达古冰川冬季活动开启",
        summary: "精彩活动与温馨提示",
      },
      {
        title: "交通指南更新",
        summary: "自驾与公共交通建议",
      },
    ],
  },
  newsDetailPage: {
    sampleTitle: "示例资讯标题",
    sampleContent:
      "<p>这里是示例内容，待 CMS 发布后将自动展示。</p><p>支持富文本样式，例如：</p><ul><li>列表项 1</li><li>列表项 2</li></ul>",
  },
  serviceTipsPage: {
    sampleContent: "<p>这里是游客须知内容...</p>",
  },
  serviceLeisurePage: {
    mockItems: ["休闲娱乐示例内容", "示例：游玩项目与体验推荐"],
  },
  panoramaLivePage: {
    defaultLocations: [
      "达古湖情人滩",
      "金报海",
      "泽娜措",
      "千里彩林",
      "洛格斯圣山",
      "索道上站",
    ],
  },
  panoramaDaguErPage: {
    mockAuthor: "FROM：爱拍照的小达{index}",
  },
};
